export default {"src":"/_next/static/media/MobileApp-white.b97d063e.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};